module.exports = __webpack_public_path__ + "static/media/kebap_back.d86eab6d.jpg";